export const Laptop: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M73.1333 56.6664V56.8664H73.3333H78.3333C79.1441 56.8664 79.8 57.5222 79.8 58.333V59.9997C79.8 63.566 76.8997 66.4664 73.3334 66.4664H6.66672C3.1003 66.4664 0.2 63.566 0.2 59.9997V58.333C0.2 57.5222 0.855914 56.8664 1.66656 56.8664H6.66656H6.86656V56.6664V19.9997C6.86656 16.4333 9.76702 13.533 13.3333 13.533H66.6666C70.233 13.533 73.1333 16.4335 73.1333 19.9997V56.6664ZM69.9998 56.8664H70.1998V56.6664V19.9997C70.1998 18.0518 68.6145 16.4664 66.6666 16.4664H13.3333C11.3853 16.4664 9.8 18.0518 9.8 19.9997V56.6664V56.8664H10H31.6667H48.3333H69.9998ZM3.33344 59.7997H3.13344V59.9997C3.13344 61.9477 4.71876 63.533 6.66672 63.533H73.3333C75.2814 63.533 76.8667 61.9477 76.8667 59.9997V59.7997H76.6667H71.6667H49.0234H48.9406L48.882 59.8583L47.7037 61.0367C47.4287 61.3118 47.0562 61.4664 46.6667 61.4664H33.3334C32.9438 61.4664 32.5715 61.3118 32.2964 61.0367L31.118 59.8583L31.0594 59.7997H30.9766H8.33344H3.33344Z"
        fill="currentColor"
        stroke="white"
        strokeWidth="0.4"
      />
    </svg>
  );
};
